import InputDocTien from "components/GenericComponent/NumberInput/InputDocTien";
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useSelector, useDispatch } from "react-redux";
import { pushNotification } from "utils/notifications";
import { useForm } from "react-hook-form";
import { convertToNumber } from "utils/numberExtension";
import TraGopApi from "service/traGopApi";
export const ModalSuaKyLai = (props) => {
  const currentForm = useForm();
  const { control } = currentForm;
  const init = {
    chovayID: props.data.ChoVayId,
    valueGop: 0,
    valueGoc: 0,
  };
  const [dataSuaKyLai, setDataSuaKyLai] = useState(init);
  const thongbaoerror = {
    Message: "",
    Error: 0,
  };
  const [isAllowDelete, setIsAllowDelete] = useState(thongbaoerror);

  const dispatch = useDispatch();

  const valueGop = React.createRef();
  const valueGoc = React.createRef();
  const initErrors = {
    valueGop: "",
  };
  const [errors, setErrors] = useState(initErrors);
  const initErrors1 = {
    valueGoc: "",
  };
  const [errors1, setErrors1] = useState(initErrors1);
  const [doubleClick, setDoubleClick] = useState(false);

  const onSubmit = () => {
    if (
      typeof props.dataTotal !== "undefined" &&
      props.dataTotal !== null &&
      props.dataTotal.TongTienLai === 0
    ) {
      if (dataSuaKyLai.valueGoc === 0) {
        setErrors1({
          ...errors1,
          valueGoc: "Nhập số tiền số tiền phải đóng của kỳ gốc",
        });
        valueGoc.current.focus();
        return;
      } else if (dataSuaKyLai.valueGop > 0) {
        setErrors({
          ...errors,
          valueGop: "Bạn không thể chỉnh sửa các kỳ lãi khi tổng là 0",
        });
        valueGop.current.focus();
        return;
      }
    } else if (
      typeof props.dataTotal !== "undefined" &&
      props.dataTotal !== null &&
      props.dataTotal.TongTienGoc === 0
    ) {
      if (dataSuaKyLai.valueGop === 0) {
        setErrors({
          ...errors,
          valueGop: "Nhập số tiền số tiền phải đóng của kỳ lãi",
        });
        valueGop.current.focus();
        return;
      } else if (dataSuaKyLai.valueGoc > 0) {
        setErrors1({
          ...errors1,
          valueGoc: "Bạn không thể chỉnh sửa các kỳ gốc khi tổng là 0",
        });
        valueGoc.current.focus();
        return;
      }
    } else {
      if (dataSuaKyLai.valueGop === 0 && dataSuaKyLai.valueGoc === 0) {
        setErrors({
          ...errors,
          valueGop: "Nhập số tiền phải đóng của kỳ lãi hoặc kỳ gốc",
        });
        valueGop.current.focus();
        return;
      }
      // if (dataSuaKyLai.valueGop === 0) {
      //   setErrors({
      //     ...errors,
      //     valueGop: "Nhập số tiền số tiền phải đóng của kỳ lãi",
      //   });
      //   valueGop.current.focus();
      //   return;
      // } else if (dataSuaKyLai.valueGoc === 0) {
      //   setErrors1({
      //     ...errors1,
      //     valueGoc: "Nhập số tiền số tiền phải đóng của kỳ gốc",
      //   });
      //   valueGoc.current.focus();
      //   return;
      // }
    }
    setDoubleClick(true);
    TraGopApi.suaKyLai(
      dataSuaKyLai.chovayID,
      dataSuaKyLai.valueGop,
      dataSuaKyLai.valueGoc
    )
      .then((response) => {
        if (response.status === 200) {
          pushNotification(
            "Bạn đã sửa kỳ lãi thành công",
            "success",
            "TOP_CENTER",
            2000
          );
          props.onHide();
          const dataSearch = {
            choVayId: props.data.ChoVayId,
            pageIndex: 1,
            pageSize: 10,
          };
          props.getLanDongLaiChoVay(dataSearch);
        } else {
          pushNotification(response.data, "error", "TOP_CENTER", 2000);
          setDoubleClick(false);
        }
      })
      .catch((error) => {
        const data = error.response && error.response.data;
        pushNotification(
          typeof data === "string" && data
            ? data
            : "Sửa kỳ lãi không thành công",
          "error",
          "TOP_CENTER",
          2000
        );
        setDoubleClick(false);
      });
  };

  const onChangeNumber = (field) => (e) => {
    setDataSuaKyLai({
      ...dataSuaKyLai,
      [field]: convertToNumber(e.value),
    });
  };
  return (
    <Modal
      {...props}
      size="modal-dialog modal-dialog modalW-new"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left"
    >
      <Modal.Header>
        <h4 className="modal-title" id="myModalLabel16">
          <span className="btn-icon-right">
            <i className="mdi mdi-pencil-circle"></i>
          </span>
          Sửa kỳ lãi
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={props.onHide}
        >
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body className="">
        <form className="form tat-toan form-horizontal">
          <div className="form-body">
            <div className="form-body">
              {/* <div className="form-group row">
                <label className="col-md-7 label-control text-left">
                  Tiền lãi phải đóng của 1 kỳ họ là:
                </label>
                <div className="col-md-5">{props.conNo} (vnđ)</div>
              </div> */}

              <InputDocTien
                labelClass="col-md-7 label-control text-left"
                inputClass="form-control input-sm"
                inputWrapClass="col-md-5"
                wrapperClass="form-group row"
                labelText="Bạn muốn thay đổi số tiền phải đóng của 1 kỳ lãi là"
                placeholder="10,000,000"
                starRed="*"
                inputProps={{
                  name: "valueGop",
                  onChange: onChangeNumber("valueGop"),
                  value: dataSuaKyLai.valueGop,
                  getInputRef: valueGop,
                  control: control,
                }}
              ></InputDocTien>
              <div className="form-group row" style={{ marginBottom: "0px" }}>
                <label className="col-md-7 label-control text-left"></label>
                <div
                  className="col-md-5"
                  style={{ marginBottom: "5px", marginTop: "-5px" }}
                >
                  {errors.valueGop && (
                    <span className="canh-bao-red">{errors.valueGop}</span>
                  )}
                </div>
              </div>

              {/* <div className="form-group row">
                <label className="col-md-7 label-control text-left">
                  Tiền gốc phải đóng của 1 kỳ họ là:
                </label>
                <div className="col-md-5">{props.conNo} (vnđ)</div>
              </div> */}
              <InputDocTien
                labelClass="col-md-7 label-control text-left"
                inputClass="form-control input-sm"
                inputWrapClass="col-md-5"
                wrapperClass="form-group row"
                labelText="Bạn muốn thay đổi số tiền phải đóng của 1 kỳ gốc là"
                placeholder="10,000,000"
                starRed="*"
                inputProps={{
                  name: "valueGoc",
                  onChange: onChangeNumber("valueGoc"),
                  value: dataSuaKyLai.valueGoc,
                  getInputRef: valueGoc,
                  control: control,
                }}
              ></InputDocTien>
              <div className="form-group row" style={{ marginBottom: "0px" }}>
                <label className="col-md-7 label-control text-left"></label>
                <div
                  className="col-md-5"
                  style={{ marginBottom: "5px", marginTop: "-5px" }}
                >
                  {errors1.valueGoc && (
                    <span className="canh-bao-red">{errors1.valueGoc}</span>
                  )}
                </div>
              </div>

              {/* <div className="form-group row" style={{ marginBottom: "0px" }}>
                <label className="col-md-4 label-control text-left"></label>
                <div
                  className="col-md-8"
                  style={{ marginBottom: "5px", marginTop: "-5px" }}
                >
                  {errors.tienThanhLy && (
                    <span className="canh-bao-red">{errors.tienThanhLy}</span>
                  )}
                </div>
              </div> */}
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-new-main btn-checknew"
          onClick={onSubmit}
          disabled={doubleClick}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-check"></i>
          </span>
          Xác nhận
        </button>

        <button
          type="button"
          className="btn btn-new-main btn-closenew"
          onClick={props.onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>
          Đóng
        </button>
      </Modal.Footer>
    </Modal>
  );
};
